// @codekit-prepend "../../node_modules/jquery/dist/jquery.js";
// @codekit-prepend "../../node_modules/foundation-sites/dist/js/foundation.min.js";
// @codekit-prepend "../../node_modules/virtual-select-plugin/dist/virtual-select.min.js";

// Add the reviewers to the post_meta.
const metaKey = 'action_reviewers';
const currentDomain = location.hostname;
const siteURL = `https://${currentDomain}/wp-json/wp/v2/action/`;
const updateTimers = {}; // Store debounce timers per postId

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.accordion-content__form-input').forEach(checkbox => {
		checkbox.addEventListener('change', () => {
			const postId = parseInt(checkbox.dataset.postid, 10);

			// Clear any existing debounce timer
			if (updateTimers[postId]) {
				clearTimeout(updateTimers[postId]);
			}

			// Set a new debounce timer (e.g. 500ms)
			updateTimers[postId] = setTimeout(() => {
				saveReviewersForPost(postId);
			}, 500);
		});
	});

	// Add Read more button for clamped text in Supplier Directory search results
	const descriptions = document.querySelectorAll('.search-results__card-content');

	function setup(desc) {
		if (!desc.id) desc.id = 'desc-' + Math.random().toString(36).slice(2, 8);

		let btn = desc.nextElementSibling;

		if (!btn || !btn.classList.contains('search-results__toggle')) {
		btn = document.createElement('button');
		btn.type = 'button';
		btn.className = 'button dropdown search-results__toggle';
		btn.setAttribute('aria-expanded', 'false');
		btn.setAttribute('aria-controls', desc.id);

		const label = document.createElement('span');
		label.textContent = 'Read more';

		const hidden = document.createElement('span');
		hidden.className = 'show-for-sr';
		hidden.textContent = ' about ' + (desc.dataset.title || '');

		btn.append(label, hidden);

		btn.addEventListener('click', () => {
			const expanded = desc.classList.toggle('is-expanded');
			btn.setAttribute('aria-expanded', expanded);
			label.textContent = expanded ? 'Read less' : 'Read more';
		});

		desc.addEventListener('focusin', () => {
			if (!desc.classList.contains('is-expanded')) btn.click();
		});

		desc.insertAdjacentElement('afterend', btn);
		}

		// Show the button only if something is actually hidden
		const first = desc.firstElementChild;
		const hasHiddenBlocks = desc.children.length > 1;
		const firstClipped = !!first && first.scrollHeight > first.clientHeight + 1;
		const hasHiddenItems = !!first?.matches('ul, ol') && first.children.length > 3;

		const isClipped = hasHiddenBlocks || firstClipped || hasHiddenItems;
		btn.hidden = !isClipped && !desc.classList.contains('is-expanded');
	}

	descriptions.forEach(setup);

	const ro = new ResizeObserver((entries) => entries.forEach((e) => setup(e.target)));
	descriptions.forEach((el) => ro.observe(el));
});

function saveReviewersForPost(postId) {
	const checkboxes = document.querySelectorAll(`.accordion-content__form-input[data-postid="${postId}"]`);
	const selectedUserIds = Array.from(checkboxes)
	.filter(cb => cb.checked)
	.map(cb => parseInt(cb.dataset.userid, 10));

	fetch(`${siteURL}${postId}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': wpApiSettings.nonce
		},
		body: JSON.stringify({
			meta: {
			[metaKey]: selectedUserIds
			}
		})
	})
	.then(res => {
		if (!res.ok) throw new Error(`Failed to update reviewers for post ${postId}`);
		return res.json();
	})
	.then(data => {
		console.log(`Reviewers updated for post ${postId}:`, data.meta[metaKey]);
	})
	.catch(err => {
		console.error(`Error updating reviewers for post ${postId}:`, err);
	});
}

// Export report on Dashboard page,
const pdfButton = document.getElementById('pdfDownload');
if(pdfButton) {
	pdfButton.addEventListener('click', function() {			
		window.print();
	})
}

// Radar chart on Dashboard page.
if( document.getElementsByClassName('page-dashboard').length > 0 ) {
	const currentDomainScores = [ domainOne, domainTwo, domainThree, domainFour, domainFive, domainSix ] = [
		parseFloat(document.getElementById('domain-score-organisational-policy-and-strategy').innerText),
		parseFloat(document.getElementById('domain-score-environment').innerText),
		parseFloat(document.getElementById('domain-score-training-and-development').innerText),
		parseFloat(document.getElementById('domain-score-recruitment-and-selection').innerText),
		parseFloat(document.getElementById('domain-score-workplace-supports').innerText),
		parseFloat(document.getElementById('domain-score-performance-and-progression').innerText)
	]

	const domainTotal = currentDomainScores.reduce((a,b)=>a+b);
	const wideScore = document.getElementById('wideScore');
	wideScore.innerText = domainTotal.toFixed(1);

	const ctx = document.getElementById('rubrik');

	Chart.defaults.font.size = 14;
	Chart.defaults.color = '#3B3C3B';
	const radarChart = new Chart(ctx, {
		type: 'radar',
		data: {
			labels: [
				'Organisational Policy and Strategy',
				'Environment',
				'Training and Development',
				'Recruitment and Selection',
				'Workplace Supports',
				'Performance and Progression'
			],
			datasets: [{
				label: 'Current Performance',
				data: currentDomainScores,
				borderWidth: 2,
				fill: true,
				backgroundColor: 'rgba(255, 99, 132, 0.2)',
				borderColor: 'rgb(255, 99, 132)',
				pointBackgroundColor: 'rgb(255, 99, 132)',
				pointBorderColor: '#fff',
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: 'rgb(255, 99, 132)'
			}],
		},
		options: {
			aspectRatio: 2,
			scales: {
				r: {
					min: 0,
					max: 4,
					ticks: {
						stepSize: 1
					},
					pointLabels: {
						font: {
							size: 14
						}
					}
				}
			}
		}
	});

	// Set aria-label on canvas element.
	let graphAriaLabel = 'Radar chart values from 0 to 4. ';
	radarChart.data.datasets[0].data.forEach((element, index) => {
		graphAriaLabel += radarChart.data.labels[index] + ': ' + element + '. ';
	});
	ctx.setAttribute('aria-label', graphAriaLabel);

	jQuery(function ($) {
		let transientArray = [];
		let transientDatasetIndex = null;
		const saveBtn = $('#saveSnapshot');
		const getBtn = $('#loadSnapshot');
		const deleteBtn = $('#clearSnapshot');

		// Function to toggle button states
		function updateButtonStates() {
			$.ajax({
				type: 'POST',
				url: ajax_object.ajax_url,
				data: {
					action: 'check_custom_transient',
					nonce: ajax_object.nonce
				},
				success: function(response) {
					if (response.success && response.data.exists) {
						// Transient exists
						saveBtn.prop('disabled', true);
						getBtn.prop('disabled', false);
						deleteBtn.prop('disabled', false);
					} else {
						// Transient does not exist
						saveBtn.prop('disabled', false);
						getBtn.prop('disabled', true);
						deleteBtn.prop('disabled', true);
					}
				},
				error: function(err) {
					console.error('Error checking transient:', err);
				}
			});
		}

		// Call on page load
		updateButtonStates();

		saveBtn.on('click', function() {
			let date = new Date();
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			let currentDate = `${day}/${month}/${year}`;

			const myData = {
				name: $('#groupID').text(),
				data: currentDomainScores,
				date: currentDate
			};

			$.ajax({
				type: 'POST',
				url: ajax_object.ajax_url,
				data: {
					action: 'set_custom_transient',
					nonce: ajax_object.nonce,
					payload: JSON.stringify(myData)
				},
				success: function(response) {
					console.log('Response:', response);
					updateButtonStates();
				},
				error: function(error) {
					console.log('AJAX error:', error);
				}
			});
		});

		getBtn.on('click', function() {
			$.ajax({
				type: 'POST',
				url: ajax_object.ajax_url,
				data: {
					action: 'get_custom_transient',
					nonce: ajax_object.nonce
				},
				success: function(response) {
					if (response.success) {
						console.log('Full response:', response.data);

						if(radarChart.data.datasets.length == 2) {
							// Remove the dataset if it exists
							const indexToRemove = radarChart.data.datasets.length - 1;

							if (indexToRemove !== -1) {
								const dataset = radarChart.data.datasets[indexToRemove];

								// Animate data to 0
								const originalData = [...dataset.data];
								dataset.data = dataset.data.map(() => 0);
								radarChart.update();

								setTimeout(() => {
									radarChart.data.datasets.splice(indexToRemove, 1);
									radarChart.update();
								}, 600);
							}
						} else {
							// Extract the array part
							transientArray = response.data.data;
							radarChart.data.datasets.push({
								label: response.data.date,
								data: transientArray,
								fill: true,
								backgroundColor: 'rgba(54, 162, 235, 0.2)',
								borderColor: 'rgb(54, 162, 235)',
								pointBackgroundColor: 'rgb(54, 162, 235)',
								pointBorderColor: '#fff',
								pointHoverBackgroundColor: '#fff',
								pointHoverBorderColor: 'rgb(54, 162, 235)'
							});
							transientDatasetIndex = radarChart.data.datasets.length;
							radarChart.update();
							console.log('Extracted array:', transientArray);
						}
					} else {
						console.warn('No transient data found.');
					}
				},
				error: function(err) {
					console.error('AJAX error:', err);
				}
			});
		});

		deleteBtn.on('click', function() {
			$.ajax({
				type: 'POST',
				url: ajax_object.ajax_url,
				data: {
					action: 'delete_custom_transient',
					nonce: ajax_object.nonce
				},
				success: function(response) {
					if (response.success) {
						// Remove the dataset if it exists
						if(radarChart.data.datasets.length == 2) {
						const indexToRemove = radarChart.data.datasets.length - 1;
							if (indexToRemove !== -1) {
								const dataset = radarChart.data.datasets[indexToRemove];

								// Animate data to 0
								const originalData = [...dataset.data];
								dataset.data = dataset.data.map(() => 0);
								radarChart.update();

								setTimeout(() => {
									radarChart.data.datasets.splice(indexToRemove, 1);
									radarChart.update();
								}, 600);
							}
						} else {
							console.warn('Transient dataset not found on chart.');
						}
						updateButtonStates();
					}
				},
				error: function(err) {
					console.error('Delete error:', err);
				}
			});
		});
	})
}

// Fix Formidable orphan form labels on multiselect fields.
let formLabels = document.querySelectorAll('.frm_forms .frm6.frm_form_field:not(.vertical_radio) div.frm_primary_label');

formLabels.forEach((label) => {
	let labelForAttr  = label.id.replace('_label', '');
	let labelHTML = label.innerHTML;
	let newlabel = document.createElement('label');
	newlabel.setAttribute('id', label.id);
	newlabel.setAttribute('for', labelForAttr);
	newlabel.setAttribute('class', 'frm_primary_label');
	newlabel.innerHTML = labelHTML;
	label.insertAdjacentElement('afterend', newlabel);
	label.remove();
})

let completeDomains = document.querySelectorAll('.accordion-title--parent .review-status__complete');
let wideText = document.getElementById('wideMessage');

if(wideText) {
	if(completeDomains.length == 6) {
		wideText.innerText = 'Review Complete';
	} else {
		wideText.innerText = 'Review in Progress: Finish review of remaining actions to get a fully accurate score.';
	}
}

// Persist search term on resource library page
if( document.getElementsByClassName('page-resource-library').length > 0 ) {
	const searchInput = document.querySelector('#searchform-resources input[type="text"]');
	const urlParams = new URLSearchParams(window.location.search);
	const searchParam = urlParams.get('q');
	if(searchParam) {
		searchInput.setAttribute('value', searchParam);
	}
}

jQuery(function ($) {
	// Call the pretty Foundation scripts
	$(document).foundation();

	if($("#searchform-resources")) {
		VirtualSelect.init({ 
			ele: '#searchform-resources select',
			multiple: true,
			search: false,
			disableSelectAll: true,
			noOfDisplayValues: 1,
			autofocus: false,
			hideClearButton: true,
			dropboxWrapper: '.resource-filter__dropdown-wrapper'
		});
	}

	if($("#searchform-suppliers")) {
		VirtualSelect.init({ 
			ele: '#searchform-suppliers select',
			multiple: true,
			search: false,
			disableSelectAll: true,
			noOfDisplayValues: 1,
			autofocus: false,
			hideClearButton: true,
			dropboxWrapper: '.supplier-filter__dropdown-wrapper'
		});
	}
	
    $('.vscomp-dropbox').append('<button class="button small close-dropdown">Done</button>');

    $('.close-dropdown').on('click', function(e) {
		e.preventDefault();
		$('.multiple-select').trigger('click');
    });

	$(".close-dropdown").keyup(
        function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
				$('.multiple-select').trigger('click');
            }
        }
    );

	// Profile page review status filter.
	$('.profile-actions__filter #complete-actions').on('click', function() {
		$('.profile-actions li.action-incomplete').each(function() {
			$(this).addClass('hide');
		})
		$('.profile-actions li.action-complete').each(function() {
			$(this).removeClass('hide');
		})
	})

	$('.profile-actions__filter #incomplete-actions').on('click', function() {
		$('.profile-actions li.action-complete').each(function() {
			$(this).addClass('hide');
		})
		$('.profile-actions li.action-incomplete').each(function() {
			$(this).removeClass('hide');
		})
	})

	$('#stautus-reset').on('click', function() {
		$('#status-list input').each(function() {
			$(this).prop('checked', false);
		})
		$('.profile-actions li.hide').each(function() {
			$(this).removeClass('hide');
		})
	})

	// Admin Dashboard
	function filterActions() {
		const selectedReviewer = $('#assigned-reviewers-list input[name="user"]:checked');
		const selectedStatus = $('#review-status-list input[name="review-status"]:checked');

		const reviewer = selectedReviewer.length ? selectedReviewer.val() : null;
		const status = selectedStatus.length ? selectedStatus.val() : null;

		$('.accordion--dashboard .accordion-item').each(function() {
			const $panel = $(this);
			const $actions = $panel.find('.accordion-content__list > li');

			let panelHasMatch = false;

			$actions.each(function() {
				const $item = $(this);

				let reviewerMatches = true;
				let statusMatches = true;

				// Reviewer filter
				if (reviewer) {
					const username = reviewer.toLowerCase().replace(/\s+/g, '');
					reviewerMatches = $item.attr('data-' + username) === 'true';
				}

				// Status filter
				if (status) {
					statusMatches = $item.is('[' + status + ']');
				}

				// Show/hide individual action
				if (reviewerMatches && statusMatches) {
					$item.removeClass('hide');
					$item.addClass('status-dropdown-selected');
					panelHasMatch = true;
				} else {
					$item.addClass('hide');
					$item.removeClass('status-dropdown-selected');
				}
			});

			// Show/hide the parent accordion panel
			if (panelHasMatch || (!reviewer && !status)) {
				$panel.removeClass('hide');
			} else {
				$panel.addClass('hide');
			}
		});
	}

	// Admin Dashboard filter by reviewer
	$('#review-status-list input').on('click', function() {
		const reviewStatus = $(this).val();
		$('.accordion--dashboard .accordion-item').addClass('is-active');
		$('.accordion--dashboard .accordion-content').show();

		filterActions();
		$('#current-filter #current-filter-reviewer').removeClass('hide');
		$('#current-filter #current-filter-reviewer').text('Selected status is: ' + reviewStatus.split('-').pop());
	});

	// Admin Dashboard filter by status
	$('#assigned-reviewers-list input').on('click', function() {
		const userName = $(this).val();
		$('.accordion--dashboard .accordion-item').addClass('is-active');
		$('.accordion--dashboard .accordion-content').show();

		filterActions();
		$('#current-filter #current-filter-status').removeClass('hide');
		$('#current-filter #current-filter-status').text('Selected reviewer is: ' + userName);
	});

	// Reviewer Dashboard
	function filterReviewerActions() {
		const selectedReviewer = $('#assigned-reviewer-list input[name="user"]:checked');
		const selectedStatus = $('#reviewer-status-list input[name="review-status"]:checked');

		const reviewer = selectedReviewer.length ? selectedReviewer.val() : null;
		const status = selectedStatus.length ? selectedStatus.val() : null;

		$('.accordion--dashboard .accordion-item').each(function() {
			const $panel = $(this);
			const $actions = $panel.find('.accordion-content__list > li');

			let panelHasMatch = false;

			$actions.each(function() {
				const $item = $(this);

				let reviewerMatches = true;
				let statusMatches = true;

				// Reviewer filter
				if (reviewer === 'All') {
					// "All" = only show actions that have a reviewer assigned
					reviewerMatches = $item.find('.accordion-content__reviewers-name').length > 0;

				} else if (reviewer) {
					// Specific reviewer
					reviewerMatches = $item.find('.accordion-content__reviewers-name').filter(function() {
						return $(this).text().trim() === reviewer;
					}).length > 0;
				}

				// Status filter
				if (status) {
					statusMatches = $item.is('[' + status + ']');
				}

				// Both filters must match
				if (reviewerMatches && statusMatches) {
					$item.removeClass('hide');
					$item.addClass('status-dropdown-selected');

					// At least one action in this panel matches
					panelHasMatch = true;
				} else {
					$item.addClass('hide');
					$item.removeClass('status-dropdown-selected');
				}
			});

			// Show/hide the parent accordion panel
			if (panelHasMatch || (!reviewer && !status)) {
				$panel.removeClass('hide');
			} else {
				$panel.addClass('hide');
			}
		});
	}

	$('#reviewer-status-list input').on('click', function() {
		const reviewerStatus = $(this).val();
		$('.accordion--dashboard .accordion-item').addClass('is-active');
		$('.accordion--dashboard .accordion-content').show();

		filterReviewerActions();
		$('#current-filter #review-filter-current').removeClass('hide');
		$('#current-filter #review-filter-current').text('Selected status is: ' + reviewerStatus.split('-').pop());
	});

	// Admin Dashboard filter by status
	$('#assigned-reviewer-list input').on('click', function() {
		const reviewer = $(this).val();
		$('.accordion--dashboard .accordion-item').addClass('is-active');
		$('.accordion--dashboard .accordion-content').show();

		filterReviewerActions();
		$('#current-filter #status-filter-current').removeClass('hide');
		$('#current-filter #status-filter-current').text('Selected reviewer is: ' + reviewer);
	});

	// Reset button
	$('#reviewers-reset').on('click', function() {
		$('#current-filter').hide();
		$('.accordion--dashboard .accordion-item').removeClass('is-active');
		$('.accordion--dashboard .accordion-item').removeClass('hide');
		$('.accordion--dashboard .accordion-content').hide();
		$('.accordion--dashboard .accordion').attr('aria-hidden', 'true');
		$('.accordion--dashboard .accordion-item .accordion-content__list li').each(function() {
			$(this).removeClass('hide');
		})
		$('#assigned-reviewers-list input').each(function() {
			$(this).prop('checked', false);
		})
		$('#review-status-list input').each(function() {
			$(this).prop('checked', false);
		})
		$('#assigned-reviewer-list input').each(function() {
			$(this).prop('checked', false);
		})
		$('#reviewer-status-list input').each(function() {
			$(this).prop('checked', false);
		})
	})

	// Bulk reviewer assignment
	$('.accordion-content__form .accordion-content__form-inner .accordion-content__form-input').each(function() {
		const parentAccordion = $(this).closest('.accordion-item');
		const dataEffortId = $(this).attr('data-effortid');
		const value = $(this).attr('value');

		if(!$(this).is(':checked')) {
			$(this).siblings('label').addClass('sr-only');
		}
		if($(this).is(':checked')) {
			parentAccordion.attr('data-'+ value.toLowerCase().replace(/ /g,'') +'', true);
			parentAccordion.children('.accordion-item__form-dropdown').find('input[data-effortid="'+ dataEffortId + '"][value="' + value + '"]').prop('checked', true);
			parentAccordion.children('.accordion-content').find('.accordion-content__list li[data-effortid="'+ dataEffortId + '"]').attr('data-'+ value.toLowerCase().replace(/ /g,'') +'', true);
		}
	})
	
	const bulkAssignReviwers = function() {
		const effortID = $(this).attr('data-effortid');
		const userID = $(this).attr('data-userid');
		const totalUserEffortActions = $('.accordion-content__form-input[data-userid="' + userID + '"][data-effortid="' + effortID + '"]').length;
		const checkedUserEffortActions = $('.accordion-content__form-input[data-userid="' + userID + '"][data-effortid="' + effortID + '"]:checked').length;

		$('.accordion-content__form-input[data-userid="' + userID + '"][data-effortid="' + effortID + '"]').each(function() {
			if(checkedUserEffortActions < totalUserEffortActions) {
				if(!$(this).is(':checked')) {
					$(this).prop('checked', true);
					$(this).closest('.accordion-item').attr('data-'+ $(this).attr('value').toLowerCase().replace(/ /g,'') +'', true);
					$(this).closest('.accordion-item').children('.accordion-content').find('.accordion-content__list li[data-effortid="'+ effortID + '"]').attr('data-'+ $(this).attr('value').toLowerCase().replace(/ /g,'') +'', true);
					$(this).siblings('label').toggleClass('sr-only');
					saveReviewersForPost($(this).attr('data-postid'));
				}
			} else if(checkedUserEffortActions === totalUserEffortActions) {
				$(this).prop('checked', false);
				$(this).closest('.accordion-item').removeAttr('data-'+ $(this).val().toLowerCase().replace(/ /g,'') +'');
				$(this).closest('.accordion-item').children('.accordion-content').find('.accordion-content__list li[data-effortid="'+ effortID + '"]').removeAttr('data-'+ $(this).attr('value').toLowerCase().replace(/ /g,'') +'');
				$(this).siblings('label').toggleClass('sr-only');
				saveReviewersForPost($(this).attr('data-postid'));
			}
		})
	}
	$('.accordion-content__form--effort fieldset input').on('click', bulkAssignReviwers);
});

// Organisation email buttons
document.addEventListener('click', function (e) {
    if (e.target.classList.contains('send-reminder') || e.target.classList.contains('revoke-invite')) {
        e.preventDefault();

        const button = e.target;
        const email = button.getAttribute('data-email');
        const isRevoke = button.classList.contains('revoke-invite');
        const action = isRevoke ? 'revoke_invitation_email' : 'send_reminder_email';
        const li = button.closest('li');

        button.disabled = true;
        button.textContent = isRevoke ? 'Revoking…' : 'Sending…';

        fetch(groupEmailActions.ajaxUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: action,
                email: email,
                group_id: '<?php $group_ids ?>',
                _ajax_nonce: groupEmailActions.nonce
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                if (isRevoke) {
                    li.remove();
                } else {
                    button.textContent = 'Sent!';
                }
            } else {
                button.textContent = 'Error';
                button.disabled = false;
            }
        })
        .catch(() => {
            button.textContent = 'Error';
            button.disabled = false;
        });
    }

	$('.page-content .page-content__inner .rmwp-toggle').prev().css('display', 'inline');
});

document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('marketing-toggle');
    const status = document.getElementById('marketing-toggle-status');

    if (!toggle) {
        return;
    }

    toggle.addEventListener('change', function () {
        const value = toggle.checked ? 1 : 0;
        toggle.disabled = true;

        fetch(marketingToggle.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'toggle_marketing',
                marketing: value,
                nonce: marketingToggle.nonce
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                status.textContent = value ? 'On' : 'Off';
            } else {
                toggle.checked = !toggle.checked;
                alert('Unable to save your preference. Please try again.');
            }
        })
        .catch(() => {
            toggle.checked = !toggle.checked;
            alert('Unable to save your preference. Please try again.');
        })
        .finally(() => {
            toggle.disabled = false;
        });
    });
});
